import { React, useEffect, useState } from "react";
import { Modal, TextField, MenuItem, Fade } from "@mui/material";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";

const DetalleFacturacionModal = ({ open, onClose, nip }) => {
    const [detalle, setDetalle] = useState([])

    const [openDetalleFacturacionModal, setOpenDetalleFacturacionModal] = useState(open);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleClose = () => {
        setOpenDetalleFacturacionModal(false);
        onClose();
    };

    useEffect(() => {
        if (open && nip) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`DetalleFacturacionMaquinaria/nip?nip=${nip}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setDetalle(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    // Manejo de errores aquí
                });
        }
    }, [open, nip]);

    const onEliminar = (id) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `DetalleFacturacionMaquinaria/idEliminar?id=${id}&usuario=0`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "DETALLE DE FACTURACION",
                    "Facturación Eliminada con Éxito",
                    "success"
                );
                request
                .get(`DetalleFacturacionMaquinaria/nip?nip=${nip}`)
                .then((result) => {
                    setDetalle(result);
                })
                .catch((error) => {
                    Swal.fire("ERROR", "No se pudo actualizar los detalles", "error");
                });
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("DETALLE DE FACTURACION", JSON.stringify(error), "error");
                return;
            });
    }

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <>
            <LoaderScreen loader={loader} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropProps={{
                    timeout: 300,
                }}
            >
                <Fade in={open}>
                    <div className="plantilla-screen-filtro-container-modal-container">
                        <div className="detalle-facturacion-modal">
                            <div className="detalle-facturacion-modal-detalle">
                                <div className="detalle-facturacion-modal-detalle-formulario">
                                    <div className="detalle-facturacion-modal-formulario-plantilla">
                                        <div
                                            className="plantilla-screen-filtro-container"
                                            id="mdlFiltros-modal"
                                        >
                                            <PlantillaScreen
                                                titulo={`DETALLE DE FACTURACIÓN DE MAQUINARIA ` + nip}
                                                className_main={1}
                                                className={"plantilla-screen-filtro-container-modal"}
                                            >
                                                <div className="cerrar-modal-button" onClick={onClose}>
                                                    X
                                                </div>
                                                <div
                                                    className={`detalle-facturacion-modal-formulario-plantilla-agregar`}
                                                >
                                                    <div className="detalle-facturacion-modal-formulario-plantilla-container scroll-4">

                                                        <div className="detalle-facturacion">
                                                            <div className="detalle-facturacion-container scroll-4">
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Línea</th>
                                                                            <th>
                                                                                <div>Sucursal</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Cliente</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Vendedor</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Primera Venta</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Fecha</div>
                                                                            </th>
                                                                            <th className="column-economico">
                                                                                <div>No. Económico</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Modelo</div>
                                                                            </th>
                                                                            <th>
                                                                                <div>Importe</div>
                                                                            </th>
                                                                            <th>
                                                                                <div style={{ color: 'transparent' }}>.</div>
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {detalle.map((det) => (
                                                                            <tr className={det.eliminado === 1 ? "fila-eliminada" : ""}
                                                                             style={{
                                                                                borderLeft: det.cancelado === 1 ? "3px solid red" : "3px solid green",
                                                                                color: det.eliminado === 1 ? "white" : (det.cancelado === 1 ? "red" : "black"),
                                                                            }} key={det.id}>
                                                                                <td className={det.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(det.scorecard)}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(det.sucursal)}</td>

                                                                                <td className={det.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(det.razonsocial)}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(det.vendedor)}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-center celda-eliminada" : "ta-center"}>{det.primera_venta}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-center celda-eliminada" : "ta-center"}>{det.fecha_venta}</td>

                                                                                <td className={det.eliminado === 1 ? "ta-center column-economico celda-eliminada" : "ta-center column-economico"}>{det.neconomico}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(det.modelo)}</td>
                                                                                <td className={det.eliminado === 1 ? "ta-right celda-eliminada" : "ta-right"}>{FormatMoney(det.importe_venta, 0)}</td>
                                                                                <td className={det.eliminado === 1 ? "celda-eliminada" : ""}>
                                                                                    <div className="listado-clientes-gestionar-detalle-button">
                                                                                        {!det.eliminado && (
                                                                                            <div className="eliminar" onClick={() => onEliminar(det.id)}>
                                                                                                <DeleteIcon /> Eliminar
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </PlantillaScreen>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    );
};

export default DetalleFacturacionModal;